import { useState, useEffect, useMemo } from "react";
import { Input, Spin, Checkbox } from "antd";
import { LoadingOutlined, EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { notification } from "antd";
import { setDataToStorage, removeFromStorage, getDataFromStorage } from '@/utils/app';
import { userStorageName } from '@/constants/user';

import { authStore } from "@/store/auth";
import { storeUser } from '@/store/user';

import type { User } from '@/types/User'

import api from "@/api/index";

import "@/styles/login.scss";

function Login() {
  const [login, setLogin] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isSaveMe, setIsSaveMe] = useState<boolean>(false)

  const [isVisible, setIsVisible] = useState<boolean>(false)

  const storageName = 'save-login';
  const storageNamePreview = 'login-preview';

  const isDisabled = !login.trim() || !password.trim();

  const onSubmit = async (event: HTMLFormElement) => {
    try {
      event.preventDefault();
      if(isDisabled) {
        return false;
      }

      if(isSaveMe) {
        const data = {
          login: login,
          password: password
        };

        setDataToStorage(storageName, JSON.stringify(data))
      } else {
        removeFromStorage(storageName)
      }

      setIsLoading(true);
      const response = await api.auth.login(login, password);

      const token: string = response.data.access_token;
      const user: User = {
        role: response.data.role,
        id: response.data.id,
      };

      authStore.setToken(token);
      storeUser.setUser(user);

      setDataToStorage(userStorageName, JSON.stringify(user))

      if (response.status === 200) {
        window.location.href = "/";
      }
    } catch (err) {
      console.error(err);
      
      notification.error({
            message: 'Ошибка'
        });

    } finally {
        setIsLoading(false);
    }
  };

  const classNamesContent = useMemo(() => {
    const baseClasses = 'login__content'
    const visibleClass = isVisible ? 'visible' : ''

    return `${baseClasses} ${visibleClass}`
  }, [isVisible])

  useEffect(() => {
    const localStorage = getDataFromStorage(storageName);
    const previewStorage = getDataFromStorage(storageNamePreview)

    const savedAuth = JSON.parse(localStorage)
    const previewStorageVal = JSON.parse(previewStorage)

    if(savedAuth) {
      setIsSaveMe(true);
      setLogin(savedAuth.login || '');
      setPassword(savedAuth.password)
    }

    if(previewStorageVal) {
      setIsVisible(true)
    } else {
      setTimeout(() => {
        setIsVisible(true)
        setDataToStorage(storageNamePreview, JSON.stringify(true))
      }, 1300)
    }
  }, [])

  return (
    <div className="login">
      <div className={classNamesContent}>
        <form onSubmit={(e) => onSubmit(e)} className="login__form">
          <h6 className="login__form__title">Vibix</h6>
          <div className="form-group">
            <label className="form-group__label">Логин</label>
            <Input
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              placeholder="Логин"
            />
          </div>

          <div className="form-group">
            <label className="form-group__label">Пароль</label>
            <Input.Password
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Пароль"
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
          </div>

          <div className="form-group form-group--row">            
            <Checkbox
                id="SaveMe"
                className="app-unchecked-checkbox"
                checked={isSaveMe}
                onChange={(event) => setIsSaveMe(event.target.checked)}
              />
              <label className={"form-group-label"} htmlFor="SaveMe">
                Запомнить меня
            </label>
          </div>

          <div className="login__form__wrap-submit">
            {isLoading ? (
              <div className="login__loader">
                <Spin size="large" indicator={<LoadingOutlined />} />
              </div>
            ) : (
              <button
                className={
                  isDisabled
                    ? "login__form__submit app-btn disabled"
                    : "login__form__submit app-btn"
                }
                aria-disabled={isDisabled}
              >
                Войти
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
